module.exports = __webpack_public_path__ + "bbd49aebffaacc5addce09eceb37063d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/crests.png
// module id = 235
// module chunks = 0